// extracted by mini-css-extract-plugin
export default {"table":"LibraryClassList_table__Y5vkH","disabled":"LibraryClassList_disabled__ouN99"};